import { Component, OnDestroy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { SpinnerService } from "../../../../core/services/spinner.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-loading-spinner",
  standalone: true,
  imports: [
    CommonModule,
    IonicModule
  ],
  templateUrl: "./loading-spinner.component.html",
  styleUrl: "./loading-spinner.component.scss",
})
export class LoadingSpinnerComponent implements OnDestroy{
  showSpinner = false;
  private subscription!: Subscription;

  constructor(
    private spinnerService: SpinnerService
  ) {
    this.subscription = this.spinnerService.spinner$.subscribe((isVisible) => {
      this.showSpinner = isVisible;
  });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
